export default function MyPage(
    {
        children,
        pageName,
        selectedPageName,
        pageClassName
    } : {
        children: any,
        pageName: string,
        selectedPageName: string,
        pageClassName: string
    }) {

    if (selectedPageName === pageName) {
        return <section className={pageClassName + " page active"}>{children}</section>;
    } else {
        return <section className={pageClassName + " page inactive"}>{children}</section>;
    }
}